import { MAIN_BG_COLOR } from 'shared/consts';
import styled from 'styled-components';

export const MarginBottom = styled.div`
	margin-bottom: 16px;

	background-color: white;
	z-index: 1;
	border-radius: 12px;
`;

export const Wrapper = styled.div`
	position: sticky;
	top: -5px;
	border-radius: 12px;
	overflow-anchor: none;
	z-index: 1;

	&.is-pinned {
		box-shadow: 0px 10px 20px rgba(87, 124, 240, 0.3);
		transition-duration: 0.7s;
	}
`;

export const HiddenContainer = styled.div`
	background: ${MAIN_BG_COLOR};
	display: flex;
	width: 100%;
	height: 20px;
	margin-bottom: -16px;
`;

export const CardContent = styled.div`
	padding: 4px 8px;
`;
